import { createAsyncThunk } from '@reduxjs/toolkit';
import { actServiceApi } from 'container/actServiceApi';
import { serializeError } from 'shared/utils/redux';
import {
  ActionPlanExistsQuery,
  ActionPlanExistsResponse,
} from 'api/dto/new/ActionPlan/ActionPlanExists.dto';
import { AppThunk } from 'reduxStore/appStore';

import { STORE_NAME } from './initialState';
import { selectActionPlanExistsQuery } from './selectors';

export const fetchActionPlanExists = createAsyncThunk<
  ActionPlanExistsResponse,
  ActionPlanExistsQuery
>(`${STORE_NAME}/fetchActionPlanExists`, (query) => actServiceApi.checkActionPlanExists(query), {
  serializeError,
});

// Re-checks the current selection after a plan is created, so every mounted consumer of
// `useActionPlanExists` moves from "create" to "view" without its own refetch logic.
export const refetchActionPlanExists = (): AppThunk => (dispatch, getState) => {
  const query = selectActionPlanExistsQuery(getState());
  if (query) dispatch(fetchActionPlanExists(query));
};
